import { Route } from "react-router-dom";
import ProviderListing from "../components/index";

const ProviderListingRoutes = () => (
  <>
    <Route path="listing" element={<ProviderListing />} />
  </>
);


export default ProviderListingRoutes;